import {combineReducers} from '@reduxjs/toolkit';

import {accountDatasetEntitlementsStateSlice} from './slices/account-dataset-entitlements-state.slice';
import {accountDatasetEntitlementsSlice} from './slices/account-dataset-entitlements.slice';

export const accountDatasetEntitlementsAssignedReducer = combineReducers({
    entitlements: accountDatasetEntitlementsSlice.reducer,
    state: accountDatasetEntitlementsStateSlice.reducer,
});
